import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";

const {getFullID} = Framework.Utilities;

export default class IPBanned extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Accounts_Ip_Bans._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 5;
		this.limit = 5;
		this.state.modalIPBanned = false;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (this.props.reportAccessListCount && prevState.data !== this.state.data) {
			this.props.reportAccessListCount('blacklist', ((this.state.data || []).length > 0 || this.state.pages > 0) ? 1 : 0);
		}
	}

	deleteIP = async (e) => {
		const [binary_id, pkey] = e.currentTarget.name.split('-');

		this.model.object.pkey = pkey;
		this.model.object.binary_id = binary_id;

		try {
			await this.model.submit(null, API.RequestType.DELETE);
			this.reloadTable();
		} catch (error) {
		}

		this.model.object.pkey = this.model.object.binary_id = '';
	};

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "IP",
				id: "ip_address",
				/** @param {Accounts_Ip_Bans_Object} obj */
				accessor: obj => (obj.ip_address)
			},
			{
				Header: "Date",
				id: "date",
				accessor: obj => (obj.date)
			},

			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Button
								name={getFullID(props.original)}
								color="danger" size={"sm"}
								block={true}
								onClick={this.deleteIP}>
								<i className={"fa fa-remove"}/>
							</Button>
						</span>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Banned IPs', "")}
							{this.renderHeaderRight("Banned IPs", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
